const WFS_LAYER_INDEX = 30
const WMS_LAYER_INDEX = 20
const WMTS_LAYER_INDEX = 10
const VECTOR_LAYER_INDEX = 50
const TEMPLATE_LAYER_INDEX = 100
const DEBUG_LAYER_INDEX = 200

export  {
  WFS_LAYER_INDEX,
  WMS_LAYER_INDEX,
  WMTS_LAYER_INDEX,
  VECTOR_LAYER_INDEX,
  TEMPLATE_LAYER_INDEX,
  DEBUG_LAYER_INDEX
}
